export default {
  SET_ROLES: function (state, payloads) {
    state.roles = payloads;
  },
};
